import { render, staticRenderFns } from "./select-user.vue?vue&type=template&id=bae64fdc&scoped=true"
import script from "./select-user.vue?vue&type=script&lang=js"
export * from "./select-user.vue?vue&type=script&lang=js"
import style0 from "./select-user.vue?vue&type=style&index=0&id=bae64fdc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae64fdc",
  null
  
)

export default component.exports